module.exports = "/packs/images/components/transient_navigation/tennis-lessons-nav-banner~c905851d0f2a9f698e1520080f9c8abc.jpg";